"use strict";

var $ = require("jquery");

let fromLeft = 0;
let targetSlide;

function navCategoriesSliderToSlide(target, event) {

    const slideWidth = $('.nav-categories-dropdown .container').width();
    const slider = $('.nav-slider');
    const sliderHeight = $('.nav-slider-height');
    const currentSlide = $('.slide.active');
    const desktopBaseHeight = $('.nav-slider-desktop-base > .slide').height();
    const slide = $('.slide');

    slide.removeClass('active');

    if (target === 'prev') {
        fromLeft = fromLeft + slideWidth;
        targetSlide = currentSlide.closest('li').closest('.slide')
        targetSlide.addClass('active');
    }
    if (target === 'next') {
        fromLeft = fromLeft + slideWidth * -1;
        targetSlide = $(event.target).closest('li').find('> .slide');
        targetSlide.addClass('active');
    }
    if (Number.isInteger(target)) {
        fromLeft = slideWidth * target * -1;
        targetSlide = $('.slide[data-level="' + target + '"]').closest('.slide').first('.slide');
        targetSlide.addClass('active');
    }

    slider.css({ 'transform': 'translateX(' + fromLeft + 'px)' });
    sliderHeight.css({ 'min-height': desktopBaseHeight + 'px' });
    sliderHeight.height(targetSlide.height());
}

export { navCategoriesSliderToSlide };